/**
 * "Download my data": the Article 15 export, saved straight from the response.
 * Settings and the "due to be deleted" screen both offer it, so it lives once.
 */
export async function downloadMyData(): Promise<{ tone: 'success' | 'danger'; text: string }> {
  try {
    const res = await fetch('/api/participant/hub/profile/export', { method: 'POST' });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.error || 'export failed');
    }
    const blob = await res.blob();
    const name = /filename="([^"]+)"/.exec(res.headers.get('Content-Disposition') || '')?.[1] || 'myfitvent-data.zip';
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return { tone: 'success', text: 'Your data is downloading as a ZIP file. Open README.txt in it first: it says what each file holds.' };
  } catch (err) {
    const msg = err instanceof Error && err.message !== 'export failed' ? err.message : 'We couldn’t build your file. Try again.';
    return { tone: 'danger', text: msg };
  }
}

/** One upcoming entry, as the deletion confirm lists it: "Quay 10k, 14 March 2027". */
export function describeUpcomingEntry(e: { eventName: string; startDate: string; timezone?: string | null }): string {
  const d = new Date(e.startDate);
  const date = Number.isNaN(d.getTime())
    ? ''
    : new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: e.timezone || 'UTC' }).format(d);
  return date ? `${e.eventName}, ${date}` : e.eventName;
}
